<template>
  <div class="welcome">
    <b-container fluid>
      <h1 class="h4">{{ $t('common.smartPhoneOrder') }}</h1>
      <img class="image" src="@/assets/images/welcome.png" alt="" />
      <p>{{ $t('welcome.smartPhoneOrderDescription') }}</p>
      <p class="link">
        <a :href="storeListUrl" target="_blank">{{ $t('welcome.availableShopList') }}</a>
      </p>
      <div v-if="isJp" class="how-to-use">
        <h2>{{ $t('welcome.operationMethod') }}</h2>
        <dl>
          <dt>{{ $t('welcome.alreadyInstalledApp') }}</dt>
          <dd>{{ $t('welcome.alreadyInstalledAppDescription') }}</dd>
          <dt>{{ $t('welcome.notInstalledApp') }}</dt>
          <dd>{{ $t('welcome.notInstalledAppDescription') }}</dd>
        </dl>
      </div>
      <div v-else class="how-to-use">
        <h2>{{ $t('welcome.operationMethod') }}</h2>
        <p>{{ $t('welcome.notInstalledAppDescription') }}</p>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  computed: {
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    storeListUrl() {
      switch (this.defaultLanguage) {
        case 'ja':
          return 'https://www.kurasushi.co.jp/app/app_storelist.html'
        case 'zh-tw':
          return 'https://www.kurasushi.tw/phoneorder'
        default:
          return 'https://www.kurasushi.co.jp/app/app_storelist.html'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.welcome {
  padding-top: 40px;
  text-align: center;

  .h4 {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: bold;
  }

  .image {
    margin-top: 24px;
    width: 140px;
  }

  p {
    margin: 20px 0 0;
    font-size: 14px;
    white-space: pre-wrap;
  }

  .how-to-use {
    margin: 30px 0 40px;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;

    h2 {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: bold;
    }

    dl {
      margin-bottom: 0;
      text-align: left;
    }

    dt {
      font-size: 14px;
    }

    dd {
      margin: 4px 0 20px;
      font-size: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      margin: 4px 0 0;
      font-size: 12px;
    }
  }
}
</style>
